export default __webpack_public_path__ + "static/media/onboardingWelcome.1c623bbf.png";